"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseStyle = parseStyle;
exports.isPositionRelative = isPositionRelative;
exports.hasHeight = hasHeight;
exports.hasElementHeight = hasElementHeight;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var POSITION = 'position';
var RELATIVE = 'relative';
var HEIGHT = 'height';
var STYLE = 'style'; // converts "style" attribute to an object

function parseStyle() {
  var style = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return style.split(';').reduce(function (acc, item) {
    if (!item) {
      return acc;
    }

    var key = item.split(':')[0].trim();
    var value = item.split(':')[1].trim();
    return Object.assign({}, acc, (0, _defineProperty2.default)({}, key, value));
  }, {});
} // if "position" is defined and is "relative"


function isPositionRelative() {
  var styleObject = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return styleObject[POSITION] && styleObject[POSITION] === RELATIVE;
} // ensure that if the "height" is defined is > 0


function hasHeight() {
  var styleObject = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return styleObject[HEIGHT] && parseInt(styleObject[HEIGHT], 10) > 0;
} // verifies that the element of the embed data, has "height" > 0 if is "position: relative"


function hasElementHeight(_ref) {
  var attributes = _ref.attributes;
  var style = (attributes.find(function (_ref2) {
    var key = _ref2.key;
    return key === STYLE;
  }) || {}).value;
  var styleObject = style && parseStyle(style) || {};
  return !isPositionRelative(styleObject) || isPositionRelative(styleObject) && hasHeight(styleObject);
}